export default __webpack_public_path__ + "c4b9979af1ede9731fd9154445097811.png";